"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PurchaseInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsFinancialProduct_1 = require("../../model/hsFinancialProduct");
var service_1 = require("../../../library/base/service");
var PurchaseInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PurchaseInit, _super);
    function PurchaseInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '理财产品购买界面初始化接口';
        _this.code = '105026';
        _this.desc = '理财产品购买界面初始化接口';
        _this.requestParams = new hsFinancialProduct_1.PurchaseInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return PurchaseInit;
}(service_1.BaseService));
exports.PurchaseInit = PurchaseInit;
//# sourceMappingURL=purchaseInit.js.map